import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';

import clsx from 'clsx';
// import { Link } from 'react-router-dom';

// components
import Grid from '@material-ui/core/Grid';
// import Breadcrumbs from '@material-ui/core/Breadcrumbs';
// import Container from '@material-ui/core/Container';
// import Modal from '@material-ui/core/Modal';
// import AddEditEvent from './components/AddEditEvent';
import Typography from 'components/shared/Typography';
// import LoadingButton from 'components/shared/LoadingButton';
// import Calendar from './components/Calendar';
// import CircularProgress from '@material-ui/core/CircularProgress';
import {
  SPACING_THIRD,
  SPACING,
  SPACING_HALF,
  SPACING_LEAST,
  SPACING_DOUBLE,
} from 'constants/spacing';
import RectangularGrid from 'components/shared/RectangularGrid';
import { Link } from '@material-ui/core';
import LoadingButton from 'components/shared/LoadingButton';
import SelectDivision from 'components/shared/SelectDivisionByCustomer';

// hooks
// import { useAllEvents, useCreateEvent, useUpdateEvent } from 'hooks/event';
import { useCreateEventByCustomer } from 'hooks/event';
import { useValidateDiscount, useActiveDiscount } from 'hooks/payment';
// import { useDivisionValue } from 'providers/DivisionProvider';

// utils
// import { arrayUniqueKey } from 'utils';

//assets
import orderSummaryImage from 'assets/images/customer/orderSummary.png';
import Input from 'components/shared/Input';
import { validateDiscount } from 'api/customer/discount';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    // minHeight: '100vh',
    minHeight: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  leftPanel: {
    width: '100%',
    // minHeight: '100vh',
    minHeight: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  rightLabelContainer: {
    textAlign: 'left',
    // direction: 'rtl'
    // borderBottom:"2px dashed",
    // borderColor:"#262626",
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      // left: '20%', /* Adjust this value to control the starting point of the border */
      width: '80%' /* Adjust this value to control the width of the border */,
      borderBottom: `2px dashed ${theme.palette.text.primary}` /* Adjust the border color using theme palette */,
    },
  },
  rightLabel: {
    textAlign: 'left',
  },
  leftLabel: {
    textAlign: 'right',
  },
  priceSection: {
    marginTop: theme.spacing(SPACING_HALF),
    paddingRight: theme.spacing(SPACING_DOUBLE),
  },
  form: {
    width: '100%',
  },
  buttonWraper: {
    marginTop: theme.spacing(SPACING),
    bottom: '0',
    position: 'relative',
  },
  monkey: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  phoneInput: {
    '& .MuiInputBase-input::placeholder': {
      textAlign: 'center',
    },
    '& .MuiInputBase-input': {
      textAlign: 'right',
      direction: 'rtl',
    },
  },
  largeLabel: {
    // marginTop: 15,
    fontSize: theme.typography.pxToRem(20),
    // borderColor: '',
    // height: '75%',
    '&:disabled': {
      color: '#959595',
    },
  },
  backButton: {
    backgroundColor: 'transparent',
    color: '#878787',
    border: '1px solid',
    borderColor: '#878787',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#333',
      borderColor: '#333',
    },
  },
  wholepage: {
    width: '100vw',
    height: '100vh',
    backgroundColor: '#e5e5e5',
  },
  mainContainer: {
    backgroundColor: '#f5f5f5',
    // borderRadius:"10px",
    position: 'relative',
    top: '15%',
    padding: '0px',

    [theme.breakpoints.down('xs')]: {
      backgroundColor: '#e5e5e5',
      top: '0',
    },
  },

  checkbox: {
    position: 'relative',
    top: '35%',
    width: '50%',
  },
  singleLineText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  deprecatedText: {
    position: 'relative',
    display: 'inline-block',
  },
  deprecatedLine: {
    position: 'absolute',
    bottom: '50%',
    left: 0,
    right: 0,
    borderBottom: `2px solid #333`,
  },
}));

function OrderSummary({ selectedBranch, selectedService, selectedTime, nextStep, prevStep }) {
  const classes = useStyles();
  const history = useHistory();

  const { mutate: getActiveDiscountMutation, isLoading: getActiveDiscountIsLoading } =
    useActiveDiscount();

  const { mutate: validateDiscountMutation, isLoading: validateDiscountIsLoading } =
    useValidateDiscount();

  const { mutate: createEventMutation, isLoading: createEventIsLoading } =
    useCreateEventByCustomer();

  const [coupon, setCoupon] = useState('');
  const [validatedDiscount, setValidatedDiscount] = useState('');

  const dateOptions = {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  };

  const applyDiscount = (amount) => {
    if (validatedDiscount === '') return amount;
    if (validatedDiscount.type === 'percent') {
      return parseInt((1 - validatedDiscount.amount / 100.0) * amount);
    }
    return amount - validatedDiscount.amount;
  };

  useEffect(() => {
    if (!selectedService) return;
    getActiveDiscountMutation(
      { service: selectedService._id },
      {
        onSuccess: (data) => {
          console.log('discount_OK', data);
          if (data?.status === 'OK') {
            setValidatedDiscount(data?.discount);
          }
        },
      }
    );
  }, [selectedService, getActiveDiscountMutation, setValidatedDiscount]);

  const onValidateDiscount = (e) => {
    validateDiscountMutation(
      { discountCode: coupon, serviceId: selectedService._id },
      {
        onSuccess: (data) => {
          console.log('discount_OK', data);
          if (data?.status === 'OK') {
            setValidatedDiscount(data?.discount);
          }
        },
      }
    );
  };

  const onSubmitNext = (e) => {
    createEventMutation(
      {
        start: selectedTime.startDate.getTime(),
        end: selectedTime.endDate.getTime(),
        service: selectedService._id,
        division: selectedService.division._id || selectedService.division,
        discountCode: validatedDiscount.discountCode,
        alreadyExists: selectedService.alreadyExists
      },
      {
        onSuccess: (data) => {
          console.log('OK_events', data);
          if (data?.status === 'OK') {
            window.location.href = data.paymentUrl;
          }
        },
      }
    );
  };

  const onSubmitPrev = (e) => {
    console.log('back!!!:', e);
    prevStep();
  };
  // console.log('selectedService', selectedService);
  return (
    <Grid container spacing={0} style={{ height: '100%', overflowX: 'hide' }}>
      <Grid item xs={12} md={6} style={{ height: '100%', padding: '3%', overflowY: 'auto' }}>
        <Grid container style={{ alignContent: 'space-between', height: '100%' }}>
          <Grid item xs={12}>
            <Grid container spacing={SPACING_HALF}>
              <Grid
                item
                xs={12}
                style={{ alignContent: 'center', textAlign: 'center', marginTop: '3%' }}
              >
                <Typography variant="h1">بررسی جزئیات</Typography>
              </Grid>

              <Grid item xs={12} style={{ alignContent: 'center', textAlign: 'center' }}>
                <Typography variant="h5" style={{ color: '#838383' }}>
                  لطفا صحت اطلاعات را با بررسی مجدد تایید کنید
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                style={{ alignContent: 'center', textAlign: 'center', marginTop: '3%' }}
              >
                <Grid container spacing={SPACING} className={classes.rightLabelContainer}>
                  <Grid item xs={6}>
                    <Typography variant="h5">عنوان سرویس</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h5">
                      {selectedService?.title?.split('/')[0] || '-'}
                    </Typography>
                  </Grid>

                  {selectedService?.title?.split('/').length > 1 && (
                    <>
                      <Grid item xs={6}>
                        <Typography variant="h5">مجری سرویس</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="h5">{selectedService?.title?.split('/')[1] || '-'}</Typography>
                      </Grid>
                    </>
                  )}

                  <Grid item xs={6}>
                    <Typography variant="h5">تاریخ انتخابی</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h5">
                      {selectedTime?.startDate?.toLocaleDateString('fa-IR', dateOptions) ||
                        '-'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h5">زمان شروع</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h5">
                      {selectedTime?.startDate?.toLocaleTimeString('fa-IR', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false,
                      }) || '-'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h5">زمان تقریبی اتمام</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h5">
                      {selectedTime?.endDate?.toLocaleTimeString('fa-IR', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false,
                      }) || '-'}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container spacing={SPACING} className={classes.priceSection}>
                  <Grid item xs={6} className={classes.rightLabel}>
                    <Typography variant="h5">مبلغ قابل پرداخت</Typography>
                  </Grid>
                  <Grid item xs={6} className={classes.leftLabel}>
                    {validatedDiscount === '' && (
                      <Typography variant="h5">
                        {`${selectedService?.deposit?.toLocaleString() || '-'} ریال`}
                      </Typography>
                    )}

                    {validatedDiscount !== '' && (
                      <Typography variant="h5" style={{ textDecoration: '#333 line-through' }}>
                        {`${selectedService?.deposit?.toLocaleString() || '-'} ریال`}
                      </Typography>
                    )}
                  </Grid>
                  {validatedDiscount !== '' && (
                    <>
                      <Grid item xs={6} className={classes.rightLabel}>
                        <Typography variant="h5">مبلغ قابل پرداخت پس از تخفیف</Typography>
                      </Grid>
                      <Grid item xs={6} className={classes.leftLabel}>
                        <Typography variant="h5">
                          {`${
                            applyDiscount(selectedService?.deposit)?.toLocaleString() || '-'
                          } ریال`}
                        </Typography>
                      </Grid>
                    </>
                  )}

                  {validatedDiscount === '' ? (
                    <>
                      <Grid item xs={8} className={classes.rightLabel}>
                        <Input
                          label="کد تخفیف"
                          fullWidth
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          value={coupon}
                          onChange={setCoupon}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={4}
                        className={classes.leftLabel}
                        style={{ alignContent: 'center', display: 'flex' }}
                      >
                        <LoadingButton
                          // className={classes.largeLabel}
                          type="submit"
                          // size="small"
                          fullWidth
                          variant="contained"
                          color="primary"
                          disabled={coupon === '' || validatedDiscount !== ''}
                          loading={validateDiscountIsLoading}
                          onClick={onValidateDiscount}
                        >
                          اعمال‌کد
                        </LoadingButton>
                      </Grid>
                    </>
                  ) : (
                    <>
                      <Grid item xs={8} className={classes.rightLabel}>
                        <Typography variant="h6">{validatedDiscount?.description}</Typography>
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        className={classes.leftLabel}
                        style={{ alignContent: 'center', display: 'flex' }}
                      >
                        <LoadingButton
                          // className={classes.largeLabel}
                          type="submit"
                          size="small"
                          fullWidth
                          variant="contained"
                          color="warning"
                          disabled={validatedDiscount === ''}
                          // loading={validateDiscountIsLoading}
                          onClick={() => setValidatedDiscount('')}
                        >
                          حذف
                        </LoadingButton>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={SPACING_HALF} style={{ bottom: 0, position: 'relative' }}>
              <Grid item xs={6} className={classes.buttonWraper}>
                <LoadingButton
                  className={classes.largeLabel}
                  type="submit"
                  // size="small"
                  fullWidth
                  variant="contained"
                  color="primary"
                  disabled={selectedService === ''}
                  onClick={onSubmitNext}
                >
                  ثبت
                </LoadingButton>
              </Grid>
              <Grid item xs={6} className={classes.buttonWraper}>
                <LoadingButton
                  className={clsx(classes.largeLabel, classes.backButton)}
                  type="submit"
                  // size="small"
                  fullWidth
                  variant="contained"
                  // color="default"
                  // disabled={selectedService === ''}
                  onClick={onSubmitPrev}
                >
                  بازگشت
                </LoadingButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6} className={classes.leftPanel}>
        <img src={orderSummaryImage} alt="left" height={'70%'} />
      </Grid>
    </Grid>
  );
}

export default OrderSummary;
